import { groq } from '#imports';

export function getQuery({ tag, offset, limit } = {}) {
  return groq`*[_type == "news" && "${tag}" in tags[]-> name] | order(publishedAt desc)[${offset}...${limit}] {
    title,
    slug,
    publishedAt,
    "tag_names": tags[]->name
  }`;
}
